module.exports = [
    { 
        id: 1, 
        frame: 0,
        content: {
            title: 'Нефтеперерабатывающий завод: производство моторного топлива из&nbsp;нефти',   
            modal: [
                `<div>
                    <p><b>Контроль качества топлива:</b></p>
                    <p><b>15</b>&nbsp;центральных заводских лабораторий, контролирующих качество выпускаемого моторного топлива</p>
                    <p><b>Более 120&nbsp;000</b> лабораторных испытаний/исследований образцов топлив в&nbsp;год (только по&nbsp;одному НПЗ)</p>
                    <p><b>18</b>&nbsp;показателей качества, по&nbsp;которым осуществляется оценка физико-химических и&nbsp;эксплуатационных свойств моторных топлив и&nbsp;оценка соответствия требованиям Технического регламента Таможенного союза и&nbsp;ГОСТ</p>
                </div>`
            ]
        }
    },
    {
        id: 2,
        frame: 75,
        content: {
            title: 'Транспортировка: перевозка топлива с&nbsp;нефтепере<span class="not-mobile-inline">-</span>рабатывающего завода Компании &laquo;Роснефть&raquo; на&nbsp;нефтебазу Компании &laquo;Роснефть&raquo;',
            modal: [
                `<div>
                    <p><b>Контроль качества топлива:</b></p>
                    <ol>
                        <li>Контроль технического состояния цистерн, в&nbsp;которых будет осуществляться транспортировка топлива</li>
                        <li>Подготовка цистерны перед наливом топлива</li>
                        <li>Лабораторный контроль качества топлива до&nbsp;транспортировки с&nbsp;нефтеперерабатывающего завода </li>
                        <li>Пломбирование цистерн</li>
                    </ol>
                </div>`
            ]
        }
    },
    {
        id: 3,
        frame: 150,
        content: {
            title: 'Нефтебаза Компании &laquo;Роснефть&raquo;: Хранение топлива',
            modal: [
                `<p><b>Контроль качества топлива:</b></p>
                <ol>
                    <li>Более 60&nbsp;испытательных лабораторий контролируют качество топлива</li>
                    <li>Более 80&nbsp;000 лабораторных испытаний образцов топлива в&nbsp;месяц </li>
                    <li>Входной контроль качества всех объёмов топлива, поступающего на&nbsp;нефтебазу</li>
                    <li>Контроль качества топлива в&nbsp;процессе хранения топлива в&nbsp;резервуарах</li>
                    <li>Арбитражные пробы&nbsp;&mdash; образцы бензина, которые проходили через нефтебазу (хранятся на&nbsp;нефтебазе на&nbsp;случай возникновения споров)</li>
                    <li>Паспортизация всех объемов топлива, отгружаемого с&nbsp;нефтебазы на&nbsp;АЗК</li>
                    <li>Автоматизированный процесс налива топлива </li>
                    <li>Ежемесячный контроль качества топлива из&nbsp;резервуаров нефтебазы</li>
                </ol>`
            ]
        }
    },
    {
        id: 4,
        frame: 225,
        content: {
            title: 'Транспортировка топлива с&nbsp;нефтебазы &laquo;Роснефть&raquo; на&nbsp;АЗС &laquo;Роснефть&raquo;',
            modal: [
                `<p><b>Контроль качества топлива:</b></p>
                <ol>
                    <li>Контроль технического состояния бензовозов</li>
                    <li>Контроль чистоты внутренней поверхности цистерны перед наливом топлива</li>
                    <li>Пломбировка транспортного средства, обеспечивающая герметичность и&nbsp;сохранность нефтепродуктов</li>
                    <li>Строго регламентированный маршрут&nbsp;&mdash; GPS-контроль движения транспортного средства</li>
                </ol>`
            ]
        }
    },
    {
        id: 5,
        frame: 298,
        content: {
            title: 'Автозаправочные комплексы &laquo;Роснефть&raquo;',
            modal: [
                `<p><b>Контроль качества топлива:</b></p>
                <ol>
                    <li>Проверка сопроводительной документации&nbsp;&mdash; паспорт на&nbsp;топливо, сертификат соответствия</li>
                    <li>Проверка пломбировки транспортного средства</li>
                    <li>Входной контроль качества топлива из&nbsp;бензовоза</li>
                    <li>Ежемесячный контроль качества топлива из&nbsp;резервуаров АЗК</li>
                    <li>Арбитражные пробы&nbsp;&mdash; образцы топлива, которые поступили на&nbsp;АЗК (хранятся на&nbsp;АЗК на&nbsp;случай возникновения споров)</li>
                    <li>Гарантия достоверности количества отпускаемого топлива. Любой водитель может потребовать провести тестовый пролив топлива (в&nbsp;специальную эталонную ёмкость)</li>
                    <li>Раздаточные колонки защищены от&nbsp;несанкционированного доступа &mdash; опломбированы.</li>
                </ol>`,
                `<p><b>Контроль качества топлива:</b></p>
                <p>11&nbsp;мобильных лабораторий</p>
                <p>Более 14000 анализов качества топлива в&nbsp;месяц.<br>
                Экспресс-анализаторы определяют качество топлива за&nbsp;20&nbsp;минут </p>
                <ul>
                    <li>температура помутнения</li>
                    <li>температура вспышки</li>
                    <li>содержание серы</li>
                    <li>октан</li>
                    <li>и&nbsp;др.</li>
                </ul>
                <div class="mobile-center">
                    <button class="to-final" id="to-final" onclick="window.showFinal();">Далее</button>
                </div>`
            ]
        }
    }
];


// WEBPACK FOOTER //
// ./js/step-data.js